import WxmGalleryCard from './src/main.vue';

WxmGalleryCard.install = function(Vue){
    Vue.component(WxmGalleryCard.name , WxmGalleryCard)
};
if (typeof window !== 'undefined' && window.Vue) {
    WxmGalleryCard.install(window.Vue);
}

export default WxmGalleryCard;